export const CATEGORIES = {
  accounting: 'ACCOUNTING',
};
